// src/components/Footer.js
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { joinCommunity } from "../services/community.api";

function Footer() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  // NEW — for expanding About & Customer Care
  const [openAbout, setOpenAbout] = useState(false);
  const [openHelp, setOpenHelp] = useState(false);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [toast, setToast] = useState(null);
// toast = { type: "success" | "error", message: string }

const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/share/17cMM7G7Gp/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/esiellshoes.lb?igsh=aDFicHVhcHdqaDRq",
  whatsapp: "https://wa.me/96179338100",
  location:
    "https://www.google.com/maps/place/Esiell+Shoes%D8%8C+Road%D8%8C+Al-Akbeh,+Majdalaiya%E2%80%AD/@34.4105733,35.8821817,15z/data=!4m6!3m5!1s0x1521f7b7388fcb8b:0xcafa1695630ff644!8m2!3d34.4105733!4d35.8821817!16s%2Fg%2F11ms4g7x_3",
};

const AGENCY_EMAIL = "mailto:info@novagrowthmedia.com";


  const TEXT = {
    EN: {
      subscribe:
        "Join our circle for exclusive drops, new Italian arrivals, and private offers.",
      about: "ABOUT",
      aboutText:
        "ESIELL is a luxury footwear destination curated with premium Italian craftsmanship. Every pair is selected with passion to offer elegance, comfort, and timeless design.",
      help: "CUSTOMER CARE",
      helpText:
        "For inquiries, size guidance, returns, or delivery assistance, our team is here to help you every day from 10 AM to 7 PM.",
      join: "STAY CONNECTED",
      disclaimer:
        "By subscribing, you accept our Terms of Service and Privacy Policy.",
      emailPlaceholder: "Your email address",
      signup: "JOIN",
      terms: "TERMS OF SERVICE",
      privacy: "PRIVACY POLICY",
customerReviews: "CUSTOMER REVIEWS",
      cookie: "COOKIE SETTINGS",
      info: "INFORMATION",
      desktopJoin:
        "Be first to discover new Italian collections, limited editions, and seasonal exclusives.",
      connect: "FOLLOW US",
      rights: "All Rights Reserved",
    },

    AR: {
      subscribe:
        "اشتركي لتصلك أحدث التصاميم الإيطالية والعروض الحصرية قبل الجميع.",
      about: "من نحن",
      aboutText:
        "إيسيل هو وجهة للأحذية الفاخرة المختارة بعناية، جميعها مصنوعة بأعلى مستويات الحرفية الإيطالية. نقدم لكِ تصاميم تجمع بين الأناقة والراحة والجودة العالية.",
      help: "خدمة الزبائن",
      helpText:
        "للاستفسارات، المساعدة في اختيار المقاس، الإرجاع أو مشاكل التوصيل، فريقنا جاهز دائماً لخدمتك من الساعة 10 صباحًا حتى 7 مساءً.",
      join: "كوني جزءاً من عالمنا",
      disclaimer: "عند الاشتراك، فأنتِ توافقين على الشروط وسياسة الخصوصية.",
      emailPlaceholder: "أدخلي بريدك الإلكتروني",
      signup: "اشتركي",
      terms: "الشروط والأحكام",
customerReviews: "مراجعات العملاء",
      privacy: "سياسة الخصوصية",
      cookie: "إعدادات الكوكيز",
      info: "المعلومات",
      desktopJoin:
        "كوني أول من يكتشف التصاميم الإيطالية الجديدة والإصدارات المحدودة والعروض الموسمية.",
      connect: "تابعينا",
      rights: "جميع الحقوق محفوظة",
    },
  };

  const t = TEXT[lang];

  const isValidEmail = (value) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};


const handleJoin = async () => {
  if (!isValidEmail(email)) {
    setToast({
      type: "error",
      message:
        lang === "EN"
          ? "Please enter a valid email address"
          : "يرجى إدخال بريد إلكتروني صحيح",
    });
    return;
  }

  try {
    setLoading(true);
    await joinCommunity(email);
    setEmail("");

    setToast({
      type: "success",
      message:
        lang === "EN"
          ? "Welcome to our community 🤍"
          : "مرحباً بكِ في مجتمعنا 🤍",
    });
  } catch {
    setToast({
      type: "error",
      message:
        lang === "EN"
          ? "Something went wrong. Please try again."
          : "حدث خطأ، يرجى المحاولة مرة أخرى",
    });
  } finally {
    setLoading(false);

    // auto hide toast
    setTimeout(() => setToast(null), 3000);
  }
};



  return (
    <footer
      dir={lang === "AR" ? "rtl" : "ltr"}
      className="
        w-full bg-[#F7F3F1] 
        pt-10 pb-12 px-6 
        md:px-14 lg:px-24 xl:px-40
        text-[#4A3F3E]
        border-t border-[#E6D8D2]
      "
    >
      {/* MOBILE */}
      <div className="md:hidden">
        <p className="text-sm leading-6 mb-6">{t.subscribe}</p>

        {/* ABOUT (Expandable) */}
        <div
          className="py-3 border-t border-[#E6D8D2] flex justify-between items-center"
          onClick={() => setOpenAbout(!openAbout)}
        >
          <span className="font-semibold tracking-wide">{t.about}</span>
          <span className="text-xl">{openAbout ? "−" : "+"}</span>
        </div>

        {/* ABOUT TEXT */}
        <div
          className={`
            overflow-hidden transition-all duration-300 
            ${openAbout ? "max-h-40 opacity-100 mt-2" : "max-h-0 opacity-0"}
          `}
        >
          <p className="text-xs leading-5 text-[#5c5150] pb-3">
            {t.aboutText}
          </p>
        </div>

        {/* CUSTOMER CARE (Expandable) */}
        <div
          className="py-3 border-t border-[#E6D8D2] flex justify-between items-center"
          onClick={() => setOpenHelp(!openHelp)}
        >
          <span className="font-semibold tracking-wide">{t.help}</span>
          <span className="text-xl">{openHelp ? "−" : "+"}</span>
        </div>

        {/* CUSTOMER CARE TEXT */}
        <div
          className={`
            overflow-hidden transition-all duration-300
            ${openHelp ? "max-h-40 opacity-100 mt-2" : "max-h-0 opacity-0"}
          `}
        >
          <p className="text-xs leading-5 text-[#5c5150] pb-3">
            {t.helpText}
          </p>
        </div>

        <button
  onClick={() => navigate("/contact")}
  className="
              w-full mt-3 py-3 bg-black text-white font-semibold text-sm 
              rounded-md tracking-wide hover:bg-[#222] transition
            "
>
  {lang === "EN" ? "Contact / Messages" : "تواصل معنا"}
</button>
<button
  onClick={() => navigate("/customer-reviews")}
  className="
    w-full mt-3 py-3 bg-[#FFF9F6] text-black font-semibold text-sm
    rounded-md tracking-wide border border-[#E6D8D2] hover:bg-white transition
  "
>
  {t.customerReviews}
</button>

        {/* SUBSCRIBE SECTION */}
        <h3 className="mt-6 font-bold tracking-wide text-[#2E3135]">
          {t.join}
        </h3>

        <p className="text-xs leading-5 mt-2">
  {lang === "EN" ? (
    <>
      By subscribing, you accept our{" "}
      <button
        type="button"
        onClick={() => navigate("/terms-of-service")}
        className="underline hover:text-black"
      >
        Terms of Service
      </button>{" "}
      and{" "}
      <button
        type="button"
        onClick={() => navigate("/privacy-policy")}
        className="underline hover:text-black"
      >
        Privacy Policy
      </button>
      .
    </>
  ) : (
    <>
      عند الاشتراك، فأنتِ توافقين على{" "}
      <button
        type="button"
        onClick={() => navigate("/terms-of-service")}
        className="underline hover:text-black"
      >
        الشروط والأحكام
      </button>{" "}
      و{" "}
      <button
        type="button"
        onClick={() => navigate("/privacy-policy")}
        className="underline hover:text-black"
      >
        سياسة الخصوصية
      </button>
      .
    </>
  )}
</p>

        <input
  type="email"
  placeholder={t.emailPlaceholder}
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  className="w-full mt-4 px-4 py-3 rounded-md border border-[#E6D8D2]"
/>

        <button
  onClick={handleJoin}
  disabled={loading}
  className={`w-full mt-3 py-3 font-semibold text-sm rounded-md transition
  ${loading
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-black text-white hover:bg-[#222]"}
`}
>
  {loading ? "..." : t.signup}
</button>

        {/* SOCIAL ICONS */}
        <div className="flex gap-4 mt-6">
  <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noreferrer">
    <img src="/icons/facebook.svg" className="w-9 h-9 opacity-80 hover:opacity-100 transition" />
  </a>

  <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer">
    <img src="/icons/instagram.png" className="w-9 h-9 opacity-80 hover:opacity-100 transition" />
  </a>

  <a href={SOCIAL_LINKS.location} target="_blank" rel="noreferrer">
    <img
  src="/icons/location-pin.svg"
  className="w-9 h-9 opacity-80 hover:opacity-100 transition text-black"
/>

  </a>

  <a href={SOCIAL_LINKS.whatsapp} target="_blank" rel="noreferrer">
    <img src="/icons/whatsapp.svg" className="w-9 h-9 opacity-80 hover:opacity-100 transition" />
  </a>
</div>


        {/* LEGAL LINKS */}
<div className="text-xs mt-6 leading-6">
  <button
    type="button"
    onClick={() => navigate("/terms-of-service")}
    className="block hover:text-black transition"
  >
    {t.terms}
  </button>

  <button
    type="button"
    onClick={() => navigate("/privacy-policy")}
    className="block hover:text-black transition"
  >
    {t.privacy}
  </button>

  <button
    type="button"
    className="block hover:text-black transition"
  >
    {t.cookie}
  </button>
</div>

    <p className="text-[11px] mt-6 text-[#2E3135]">
          © {new Date().getFullYear()} 
        </p>

        <p className="text-[16px] mt-4 text-[#7A7674] tex">
  <a
    href={AGENCY_EMAIL}
    className="underline hover:text-black transition"
  >
    NOVA Growth Media
  </a>
</p>


        
      </div>

      {/* DESKTOP (UNCHANGED) */}
      <div className="hidden md:grid md:grid-cols-3 gap-16">
        {/* COLUMN 1 */}
        <div>
          <h3 className="font-semibold text-lg text-[#2E3135] mb-4">
            {t.info}
          </h3>

          <div className="space-y-3 text-sm">
            <p className="hover:text-black transition">{t.about}</p>
<button
  onClick={() => navigate("/customer-reviews")}
  className="block hover:text-black transition"
>
  {t.customerReviews}
</button>
            <p className="hover:text-black transition">{t.help}</p>

<button
  type="button"
  onClick={() => navigate("/terms-of-service")}
  className="block text-start hover:text-black transition"
>
  {t.terms}
</button>

<button
  type="button"
  onClick={() => navigate("/privacy-policy")}
  className="block text-start hover:text-black transition"
>
  {t.privacy}
</button>

<button
  type="button"
  className="block text-start hover:text-black transition"
>
  {t.cookie}
</button>
          </div>
        </div>

        {/* COLUMN 2 */}
        <div>
          <h3 className="font-semibold text-lg text-[#2E3135]">
            {t.join}
          </h3>

          <p className="text-sm leading-6 mt-3">{t.desktopJoin}</p>
<p className="text-xs leading-5 mt-2 text-[#665B58]">
  {lang === "EN" ? (
    <>
      By subscribing, you accept our{" "}
      <button
        type="button"
        onClick={() => navigate("/terms-of-service")}
        className="underline hover:text-black"
      >
        Terms of Service
      </button>{" "}
      and{" "}
      <button
        type="button"
        onClick={() => navigate("/privacy-policy")}
        className="underline hover:text-black"
      >
        Privacy Policy
      </button>
      .
    </>
  ) : (
    <>
      عند الاشتراك، فأنتِ توافقين على{" "}
      <button
        type="button"
        onClick={() => navigate("/terms-of-service")}
        className="underline hover:text-black"
      >
        الشروط والأحكام
      </button>{" "}
      و{" "}
      <button
        type="button"
        onClick={() => navigate("/privacy-policy")}
        className="underline hover:text-black"
      >
        سياسة الخصوصية
      </button>
      .
    </>
  )}
</p>

          <input
  type="email"
  placeholder={t.emailPlaceholder}
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  className="w-full mt-4 px-4 py-3 rounded-md border border-[#E6D8D2]"
/>

<button
  onClick={handleJoin}
  disabled={loading}
  className={`w-full mt-3 py-3 font-semibold text-sm rounded-md transition
  ${loading
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-black text-white hover:bg-[#222]"}
`}
>
  {loading ? "..." : t.signup}
</button>
        </div>

        {/* COLUMN 3 */}
        <div>
          <h3 className="font-semibold text-lg text-[#2E3135]">
            {t.connect}
          </h3>

          <div className="flex gap-4 mt-4">
  <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noreferrer">
    <img src="/icons/facebook.svg" className="w-10 h-10 opacity-80 hover:opacity-100 transition" />
  </a>

  <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer">
    <img src="/icons/instagram.png" className="w-10 h-10 opacity-80 hover:opacity-100 transition" />
  </a>

  <a href={SOCIAL_LINKS.location} target="_blank" rel="noreferrer">
    <img
  src="/icons/location-pin.svg"
  className="w-10 h-10 opacity-80 hover:opacity-100 transition text-black"
/>

  </a>

  <a href={SOCIAL_LINKS.whatsapp} target="_blank" rel="noreferrer">
    <img src="/icons/whatsapp.svg" className="w-10 h-10 opacity-80 hover:opacity-100 transition" />
  </a>
</div>


          <p className="text-xs mt-6 mb-6">
  © {new Date().getFullYear()} 
  <br />
  {t.rights}.
  <br />
  <span className="text-[18px] text-[#7A7674] my-10">
    
    <a
      href={AGENCY_EMAIL}
      className="underline hover:text-black transition my-10"
    >
      NOVA Growth Media
    </a>
  </span>
</p>

        </div>
      </div>

{/* TOAST */}
{toast && (
  <div className="fixed inset-0 flex items-end justify-center pointer-events-none z-50">
    <div
      className={`
        mb-6 px-6 py-4 rounded-xl shadow-2xl
        text-sm font-semibold tracking-wide
        transition-all duration-300 animate-fadeSlide
        ${toast.type === "success"
          ? "bg-black text-white"
          : "bg-red-600 text-white"}
      `}
    >
      {toast.message}
    </div>
  </div>
)}


    </footer>
  );
}

export default Footer;
